import { render, staticRenderFns } from "./BackupsTable.vue?vue&type=template&id=20ada197&scoped=true"
import script from "./BackupsTable.vue?vue&type=script&lang=js"
export * from "./BackupsTable.vue?vue&type=script&lang=js"
import style0 from "./BackupsTable.vue?vue&type=style&index=0&id=20ada197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ada197",
  null
  
)

export default component.exports